import React from "react";
import { Link } from "react-router-dom";

const AboutSection: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h6 className="text-primary font-semibold mb-2">About Us</h6>
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6">
              Who We Are?
            </h2>
            <p className="text-gray-600 mb-6">
              Founded in 1999 by Manoj Kumar Singh, our NGO is dedicated to
              empowering women, educating communities, and promoting health. We
              focus on women empowerment, skill development, rural sanitation,
              the Swachh Bharat mission, and cancer-related health initiatives.
              Our goal is to create a sustainable and equitable future for all.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-primary rounded-full mr-2"></div>
                <span className="text-gray-700">Women Empowerment</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-primary rounded-full mr-2"></div>
                <span className="text-gray-700">Rural Sanitation</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-primary rounded-full mr-2"></div>
                <span className="text-gray-700">Cancer Health</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-primary rounded-full mr-2"></div>
                <span className="text-gray-700">Swachh Bharat Mission</span>
              </div>
            </div>

            <Link to="/donate" className="btn-primary inline-block">
              Donate Now
            </Link>
          </div>

          <div className="relative">
            <div className="relative rounded-lg overflow-hidden shadow-xl">
              <img
                src="/volunteers.avif"
                alt="Our Volunteer Team"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-lg">
              <div className="flex flex-col space-y-1">
                <span className="text-4xl font-bold text-primary">30+</span>
                <span className="text-gray-600">Campaigns</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
